// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__sVsE4","pagination-button":"styles_pagination-button__XO5Vc","disabled":"styles_disabled__7g0GO","active":"styles_active__lj0-U"};